let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lFwfY")).then(() => parcelRequire('700d3'));